import { render, staticRenderFns } from "./NewUiStatusBadge.vue?vue&type=template&id=eb6729fc&"
import script from "./NewUiStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./NewUiStatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports